const Types = {
	AUTH_SET_SESSION: 'AUTH_SET_SESSION',
	LOGOUT: 'LOGOUT',
	SPINNER_ROUTE: 'SPINNER_ROUTE',
	AUTHENTICATED: 'AUTHENTICATED'
};

export default Types;
